/** Telugu (India) locale for system-settings-ui. */
import type { SystemSettingsLocale } from './en'

export const systemSettingsTeIn = {
  systemSettings: {
    title: `సిస్టమ్ సెట్టింగ్‌లు`,
    tabs: {
      general: `సాధారణ`,
      defaults: `డిఫాల్ట్‌లు`,
      recording: `కాల్ రికార్డింగ్`,
    },
    common: {
      save: `మార్పులను సేవ్ చేయి`,
      active: `యాక్టివ్`,
      inactive: `ఇన్‌యాక్టివ్`,
      yes: `అవును`,
      no: `కాదు`,
      loading: `లోడ్ అవుతోంది...`,
      selectOption: `-- ఎంచుకోండి --`,
      none: `ఏమీ లేదు`,
      unsavedChanges: `సేవ్ చేయని మార్పులు`,
    },
    general: {
      title: `సాధారణ`,
      defaultTimeZone: `డిఫాల్ట్ టైమ్ జోన్`,
      callParkTimeout: `కాల్ పార్క్ టైమ్‌అవుట్ (సెకన్లు)`,
      callParkTimeoutHelp:
        'కాల్ పార్క్ చేయబడిన తర్వాత తిరిగి రావడానికి సెకన్లలో సమయం. కనిష్టం 30 సెకన్లు, గరిష్టం 1800 సెకన్లు. సిఫార్సు: 300.',
      callParkWarning: `కాలర్‌లను {{minutes}} నిమిషాల పాటు పార్కింగ్‌లో ఉంచాలనుకుంటున్నారా?`,
      extensionsTitle: `ఎక్స్‌టెన్షన్‌లు`,
      extensionDigits: `ఎక్స్‌టెన్షన్ అంకెలు`,
      enableIntercom: `ఇంటర్‌కామ్ ఎనేబుల్ చేయి`,
      searchTimezone: 'టైమ్‌జోన్‌లను శోధించండి...',
      noTimezonesFound: 'టైమ్‌జోన్‌లు కనుగొనబడలేదు',
    },
    defaults: {
      voiceTitle: `వాయిస్`,
      defaultAreaCode: `డిఫాల్ట్ ఏరియా కోడ్`,
      areaCodeRange: `ఏరియా కోడ్ 200 మరియు 998 మధ్య ఉండాలి`,
      areaCodeDisallowed: `ఈ ఏరియా కోడ్ అనుమతించబడదు`,
      defaultCallerId: `డిఫాల్ట్ కాలర్ ID`,
      faxTitle: `ఫ్యాక్స్`,
      defaultFaxNumber: `డిఫాల్ట్ ఫ్యాక్స్ నంబర్`,
      defaultVirtualFax: `డిఫాల్ట్ వర్చువల్ ఫ్యాక్స్`,
      defaultVirtualFaxSearchPlaceholder: `వర్చువల్ ఫ్యాక్స్ ఎక్స్‌టెన్షన్‌లను శోధించండి...`,
      defaultVirtualFaxSearchAriaLabel: `పేరు లేదా నంబర్ ద్వారా వర్చువల్ ఫ్యాక్స్ ఎక్స్‌టెన్షన్‌లను శోధించండి`,
      defaultVirtualFaxNoMatches: `ఆ శోధనతో ఏ వర్చువల్ ఫ్యాక్స్ ఎక్స్‌టెన్షన్ సరిపోలడం లేదు.`,
      emergencyTitle: `అత్యవసర డిఫాల్ట్‌లు`,
      emergencyName: `అత్యవసర పేరు`,
      emergencyNumber: `అత్యవసర నంబర్`,
      emergencyNumberHelp: `ఈ ఫీల్డ్ రీడ్-ఓన్లీ మరియు ఇక్కడ మార్చలేము.`,
      emergencyAlert: `అత్యవసర హెచ్చరిక`,
      holdMusicTitle: `హోల్డ్ మ్యూజిక్`,
      holdMusicPlaylist: `హోల్డ్ మ్యూజిక్`,
      noPlaylists: `ప్లేలిస్ట్‌లు అందుబాటులో లేవు`,
      playlistNotPlayableSuffix: `(ఆడియో ట్రాక్‌లు లేవు)`,
      playlistEmptyError: `ఎంచుకున్న హోల్డ్ మ్యూజిక్ ప్లేలిస్ట్‌లో ఆడియో ట్రాక్‌లు లేవు. ట్రాక్‌లను జోడించండి లేదా వేరే ప్లేలిస్ట్‌ను ఎంచుకోండి.`,
    },
    recording: {
      title: `కాల్ రికార్డింగ్`,
      enableInbound: `ఇన్‌బౌండ్ కాల్ రికార్డింగ్ ఎనేబుల్ చేయి`,
      enableOutbound: `అవుట్‌బౌండ్ కాల్ రికార్డింగ్ ఎనేబుల్ చేయి`,
      enableInternal: `ఇంటర్నల్ కాల్ రికార్డింగ్ ఎనేబుల్ చేయి`,
    },
    toast: {
      saveSuccess: `సెట్టింగ్‌లు విజయవంతంగా సేవ్ చేయబడ్డాయి`,
      saveError: `సెట్టింగ్‌లను సేవ్ చేయడం విఫలమైంది`,
      validationError: `సేవ్ చేయలేము — దయచేసి పైన ఉన్న లోపాలను సరిచేయండి`,
    },
    error: {
      loadFailed: `సిస్టమ్ సెట్టింగ్‌లను లోడ్ చేయడం విఫలమైంది. దయచేసి మళ్ళీ ప్రయత్నించండి.`,
    },
  },
} satisfies SystemSettingsLocale
